export const findMaxHorizonInDays = (horizons: string[] | undefined) => {
  if (!horizons || horizons.length === 0) {
    return 0;
  }

  const unitToDays: { [unit: string]: number } = {
    w: 7,
    m: 30,
  };

  const horizonsToDays = horizons
    .map(horizon => {
      const unit = horizon.slice(-1);
      const valueStr = horizon.slice(0, -1);

      const value = parseInt(valueStr, 10);
      const multiplier = unitToDays[unit];

      if (isNaN(value) || multiplier === undefined) {
        return undefined;
      }

      return value * multiplier;
    })
    .filter(val => val !== undefined);

  if (horizonsToDays.length === 0) {
    return 0;
  }

  return Math.max(...horizonsToDays);
};
